import type { ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { CardHeader } from './card-header';

export interface CardProps
    extends CommonProps,
        VariantProps<typeof CardStyles> {
    children?: ReactNode;
}

export const CardStyles = tv({
    slots: {
        root: 'xs:p-9 rounded-xl bg-gray-900 p-6 py-9',
    },
});

export const Card = ({
    className,
    children,
    testId = 'card',
    ...props
}: CardProps): JSX.Element => {
    const { root } = CardStyles();
    return (
        <div className={root({ className })} {...props} data-testid={testId}>
            {children}
        </div>
    );
};

Card.Header = CardHeader;
